<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col adviceBox" v-if="comment!==null">
                <p class="ml-3" v-html="comment"></p>
            </div>
        </div>


        <div class="row">
            <div class="col adviceBox" v-if="advice3!==null">
                <p class="ml-3" v-html="advice3"></p>
            </div>
        </div>


    </div>
</template>

<script>
import CalcUtil from "@/store/calcUtil.js"
export default {
    name: "Advice.vue",
    props: [
        'calc',
        'isShinchiku',
        'shushiList',
        'kansaiNenrei',
    ],
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        comment() {
            let plan = 'shinchiku';

            let sign = 'plus';
            if (this.calc.mochiieRuisekiShushi < 0) {
                sign = 'minus';
            }
            if (this.calc.totalPlusMinus < 0) {
                sign = 'minus';
            }
            //マイナスでお子様がいる場合は、お子様のアドバイス（advice3）を表示するので、メインアドバイスはスキップする
            if (this.$store.state.okosama.ages.length > 0) {
                return null;
            }

            let minusStartAge = '';
            Object.keys(this.shushiList).forEach(age=> {
                if (minusStartAge !== '') {
                    return;
                }

                let kingaku = this.shushiList[age];

                if (kingaku < 0) {
                    minusStartAge = age;
                }
            });

            let shusiText = this.calc.mochiieRuisekiShushi*1;
            if (!isNaN(shusiText)) {
                shusiText = CalcUtil.manYenToOkuYen(shusiText);
            }else{
                shusiText = 0;
            }

            let okosamaText = '';
            let okosamaUnder18 = false;
            this.$store.state.okosama.ages.forEach(ok=> {
                // console.log(ok);
                if (ok.age <= 18) {
                    okosamaUnder18 = true;
                }
            });
            if (okosamaUnder18){
                let okosamaTexts = {
                    'shinchiku':'お子さまは18歳で一人暮らしを始められる場合も多く、新居でのお子さまとの生活時間は大変貴重です。<br>',
                }
                okosamaText = okosamaTexts[plan];
            }



            let comment = {
                shinchiku: {
                    plus:'お客さまの入力情報を基にした計算では、今すぐ持家を購入した場合、90歳時点で収支（貯蓄額）が_SHUSHI_TEXT_万円プラスになると算出されました。<br>' +
                        'お客さまのご世帯は「老後2,000万円不足問題」の影響を受ける可能性が低い試算結果です。<br>' +
                        '<br>' +
                        'また、早期の持家購入により、快適に暮らせる期間が長くなります。<br>' +
                        '_OKOSAMA_TEXT_' +
                        '住宅ローン減税や計画的な繰り上げ返済などを加味した、より詳細なライフプランをミサワホームの担当と一緒に設計してみませんか。<br>' +
                        '<br>' +
                        '※本試算は、「現時点の収入」が定年まで続く場合の簡易シミュレーションです。将来の収入増を加味するなど、ご自身の展望を含めて検討しましょう。<br>' +
                        '<br>'+
                        '※本試算は、「現在の住居費」が一生涯続くという条件でのシミュレーション結果です。社宅等で入居期限が定まっている場合は、退去後の家賃を想定して詳細シミュレーションを行ってみることをおすすめします。',

                    minus:'収入と支出が逆転をする時期には、貯蓄を切り崩していくことになります。そのため、<span>計画的な貯蓄や資産形成を検討する必要があります。</span><br>' +
                        '又、住宅をご購入されるにあたっては、<span>住まいのトータルコストも意識されることをオススメします。</span><br>' +
                        '<br>' +
                        '住宅取得費等の<span>イニシャルコスト</span>、光熱費等の<span>ランニングコスト</span>、住宅修繕費等の<span>メンテナンスコスト</span>の３つを合わせた<span>トータルコスト</span>という考え方が、今の住宅業界では主流となっています。<br>' +
                        '<br>' +
                        'イニシャルコストが抑えられた場合でも、ランニング・メンテナンスの両コストが大きくかかる場合には却って家計を圧迫する可能性もあります。そういったことも鑑みたうえで、将来に渡る家計シミュレーションを実施しておくことで、ご不安を解消することができるかもしれません。<br>' +
                        '<br>' +
                        '計画的な貯蓄や資産形成、教育費の厳しい時期には一時的に教育ローンを利用するなどといった対策まで、一度担当者と一緒に考えてみませんか？'

                    // minus:'収入と支出が逆転をする時期には、貯蓄を切り崩していくことになります。そのため、計画的な貯蓄や資産形成を検討する必要があります。又、住宅をご購入されるにあたっては、住まいのトータルコストも意識されることをオススメします。<br>' +
                    //     '住宅取得費等のイニシャルコスト、光熱費等のランニングコスト、住宅修繕費等のメンテナンスコストの３つを合わせたトータルコストという考え方が、今の住宅業界では主流となっています。イニシャルコストが抑えられた場合でも、ランニング・メンテナンスの両コストが大きくかかる場合には却って家計を圧迫する可能性もあります。そういったことも鑑みて、将来に渡る家計シミュレーションを実施しておくことで、ご不安を解消することができるかもしれません。<br>' +
                    //     '一度、ミサワホームの担当者と一緒に資金シミュレーションをしてみませんか？<br>' +
                    //     '計画的な貯蓄や資産形成、教育費の厳しい時期には一時的に教育ローンを利用するなどといった対策まで、一度担当者と一緒に考えてみませんか？<br>',
                },

            }

            return comment[plan][sign].replace('_SHUSHI_TEXT_', shusiText).replace('_OKOSAMA_TEXT_', okosamaText).replace('_MINUS_START_AGE_', minusStartAge);

        },
        advice3(){

            let okosamaUnder22 = false;
            this.$store.state.okosama.ages.forEach(ok=> {
                // console.log(ok);
                if (ok.age <= 22) {
                    okosamaUnder22 = true;
                }
            });
            if (!okosamaUnder22) {
                return null;
            }


            let plan = 'shinchiku';

            //収支をループしてマイナスになるタイミングがあるか調べている
            let sign = 'plus';
            let peakAge = this.calc.shusiMinimumPeakAge;

            Object.keys(this.shushiList).forEach(age => {

                if (this.shushiList[age] < 0) {
                    sign = 'minus'
                }

            });

            //一時期の収支がマイナスになり且つトータル収支もマイナスになる場合
            if (sign === 'minus' && this.calc.mochiieRuisekiShushi < 0) {
                sign = 'totalMinus';
            }

            let texts = {

                shinchiku: {
                    plus: 'お子さまの入学など教育費が増える_PEAK_AGE_歳時点の収支が少なくはなるものの、お客さまのご家庭では、90歳時点の貯蓄額はマイナスにならない試算結果となりました。<br>' +
                        'しかし、あくまで現時点の試算結果です。この時期をさらに安心して迎えられるように、計画的な貯蓄や資産形成をしておくことをおすすめします。',
                    minus: '<span>教育費がピークとなる時期には多くのご家庭で支出が収入を上回る試算となるため、' +
                        '過度な心配はなさらないでください。</span>しかし、何の対策も講ずることなくこの時期を迎えることはリスクが高いと言えます。<br>' +
                        '<br>'+
                        '最も危険なのは単に住宅取得費(イニシャルコスト)を抑えることがリスク対策だとお考えになることです。一般的に取得費が抑えられる家＝住宅性能があまり高くない家と考えられます。<br>'+
                        '<br>'+
                        '仮にイニシャルコストが抑えられたとしても、光熱費といったランニングコストや修繕費といったメンテナンスコストが<span>教育費のピークと重なってしまい、余計に家計を圧迫…</span>といったリスクも考えられるのです。<br>' +
                        '<br>' +
                        '今や<span>住まいはトータルコスト</span>で考える時代。ミサワホームがご提案するライフシミュレーションでは、イニシャルコストのみならずランニングコストやメンテナンスコストまで含めた<span>総合的な家計収支シミュレーション</span>を作成することができます。<br>' +
                        '<br>' +
                        '計画的な貯蓄や資産形成、教育費の厳しい時期には一時的に教育ローンを利用するなどといった対策まで、一度担当者と一緒に考えてみませんか？',
                  totalMinus: '<span>教育費がピークとなる時期には多くのご家庭で支出が収入を上回る試算となるため、' +
                        '過度な心配はなさらないでください。</span>しかし、何の対策も講ずることなくこの時期を迎えることはリスクが高いと言えます。<br>' +
                        '<br>'+
                        '最も危険なのは単に住宅取得費(イニシャルコスト)を抑えることがリスク対策だとお考えになることです。一般的に取得費が抑えられる家＝住宅性能があまり高くない家と考えられます。<br>'+
                        '<br>'+
                        '仮にイニシャルコストが抑えられたとしても、光熱費といったランニングコストや修繕費といったメンテナンスコストが<span>教育費のピークと重なってしまい、余計に家計を圧迫…</span>といったリスクも考えられるのです。<br>' +
                        '<br>' +
                        '今や<span>住まいはトータルコスト</span>で考える時代。ミサワホームがご提案するライフシミュレーションでは、イニシャルコストのみならずランニングコストやメンテナンスコストまで含めた<span>総合的な家計収支シミュレーション</span>を作成することができます。<br>' +
                        '<br>' +
                        '計画的な貯蓄や資産形成、教育費の厳しい時期には一時的に教育ローンを利用するなどといった対策まで、一度担当者と一緒に考えてみませんか？',
                },
            }

            return texts[plan][sign].replace('_PEAK_AGE_', peakAge);
        },


    }
}
</script>

<style lang="scss">

.adviceBox {
    span {
      font-weight: bold;
    }
}

</style>

<style scoped lang="scss">
.adviceTitleBox{
    background-color: #FCF150;
    background-image:
        linear-gradient(0deg, #fff 50%, transparent 50%);
    background-size: 3px 3px;
    margin-bottom: 10px;
    p{
        margin:3px 0;
        font-weight: bold;
    }
}
.adviceBox {
    border: #D9ECFA 5px solid;
    border-radius: 25px;
    padding: 10px 20px 10px 10px;
    margin-bottom: 10px;
    min-height: 79px;

    p {
        margin-bottom: unset;
    }

}

@media screen and (max-width: 576px) {

    .adviceBox {

        p {
            //margin-left: 10px;
        }

    }

}

</style>